/**
 * Gemeinsamer Druck-Helper für Buchungsbelege.
 *
 * Wird von V1b sowohl aus dem StockMovementFlow (Auto-Print nach
 * Buchung) als auch aus der Buchungshistorie (manuelles Drucken)
 * aufgerufen. Läuft ausschließlich über die bestehende ``lib/print.js``
 * — kein UA-Sniffing, kein Opera-GX-Hack.
 */
import { openPrintReport } from "./print";

const BOOKING_LABEL = {
  GOODS_RECEIPT: "Wareneingang",
  GOODS_ISSUE: "Warenausgang",
  TRANSFER: "Umlagerung",
};

export function openReceiptPrint(br) {
  if (!br) return { ok: false };
  const filters = [
    { label: "Belegnummer", value: br.receipt_number },
    { label: "Typ", value: BOOKING_LABEL[br.booking_type] || br.booking_type },
    { label: "Zeitpunkt", value: new Date(br.occurred_at).toLocaleString("de-DE") },
  ];
  if (br.from_location_name) filters.push({ label: "Von", value: br.from_location_name });
  if (br.to_location_name) filters.push({ label: "Nach", value: br.to_location_name });
  if (br.user_email) filters.push({ label: "Erfasst durch", value: br.user_email });
  if (br.notes) filters.push({ label: "Bemerkung", value: br.notes });

  const rows = (br.items || []).map((it) => [
    it.product_name || it.product_id,
    it.product_ean || "",
    it.product_internal_id || "",
    String(it.quantity),
    it.previous_stock !== null && it.previous_stock !== undefined ? String(it.previous_stock) : "—",
    it.resulting_stock !== null && it.resulting_stock !== undefined ? String(it.resulting_stock) : "—",
    it.unit_price !== null && it.unit_price !== undefined
      ? it.unit_price.toFixed(2).replace(".", ",")
      : "",
  ]);

  return openPrintReport({
    area: `Buchungsbeleg ${br.receipt_number}`,
    filters,
    columns: [
      { label: "Produkt" },
      { label: "EAN" },
      { label: "SKU" },
      { label: "Menge", align: "right" },
      { label: "Vorher", align: "right" },
      { label: "Nachher", align: "right" },
      { label: "Einzelpreis", align: "right" },
    ],
    rows,
    resultCount: rows.length,
  });
}
